/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCloudEdit = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M17.12 15.225a1 1 0 0 1 1.337.068l2.25 2.25a1 1 0 0 1 0 1.414L16.664 23H13v-3.664l4.043-4.043zM15 20.165V21h.836l2.75-2.75-.836-.836zM16 15h-6v1h3v2h-3v2h1v2H8v-9h8z" />
        <path d="M15 4a4.998 4.998 0 0 1 4.994 4.802A5.995 5.995 0 0 1 23 14a6.25 6.25 0 0 1-.5 2.386l-1.845-.772A4.24 4.24 0 0 0 21 14a4 4 0 0 0-2.433-3.68l-.673-.288.07-.73.017-.132.012-.094A.643.643 0 0 0 18 9a3 3 0 0 0-3-3 2.988 2.988 0 0 0-2.964 2.684l-.166 1.556-1.342-.804A2.957 2.957 0 0 0 9 9a3 3 0 0 0-3 3v1.535l-.445.297c-1.236.824-1.885 2.08-2.222 3.205a8.26 8.26 0 0 0-.225.963H6v2H1v-1h1-1v-.023a3.902 3.902 0 0 1 .007-.204 10.324 10.324 0 0 1 .41-2.31C1.793 15.209 2.535 13.65 4 12.494V12a5 5 0 0 1 5-5c.475 0 .93.07 1.357.194A4.974 4.974 0 0 1 15 4z" />
      </g>
    </g>
  </Icon>
);
export { SvgCloudEdit as CloudEdit };
